if (!customElements.get("td-default-product-atc-price")) {
  class TdDefaultProductAtcPrice extends HTMLElement {
    constructor() {
      super();
      
      /* Store unit price and compare-at price in cents from data attributes */
      this.unitPrice = parseInt(this.dataset.unitPrice) || 0;
      this.compareAtPrice = this.dataset.compareAtPrice !== undefined && this.dataset.compareAtPrice !== '' ? parseInt(this.dataset.compareAtPrice) : null;
      this.sectionId = this.dataset.sectionId || '';
      
      /* Element references */
      this.quantityInput = null;
      this.priceDisplay = null;
      this.stickyPriceDisplay = null;
    }

    connectedCallback() {
      this.initElements();
      this.initListeners();
    }

    initElements() {
      this.quantityInput = this.querySelector('input[name="quantity"]');
      this.priceDisplay = this.querySelector('[data-atc-price]');
      
      /* Find sticky ATC price display if it exists */
      const stickyAtc = document.querySelector('.td-default-product ~ th-sticky-atc');
      if (stickyAtc) {
        this.stickyPriceDisplay = stickyAtc.querySelector('[data-atc-price]');
      }

      if (!this.quantityInput || !this.priceDisplay) {
        return;
      }

      /* Set initial price */
      this.updatePrice();
    }

    initListeners() {
      if (!this.quantityInput) return;

      /* Listen for quantity input changes */
      this.quantityInput.addEventListener('change', () => this.updatePrice());
      this.quantityInput.addEventListener('input', () => this.updatePrice());

      /* Listen for plus/minus button clicks */
      const minusBtn = this.querySelector('.minus');
      const plusBtn = this.querySelector('.plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          setTimeout(() => this.updatePrice(), 10);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          setTimeout(() => this.updatePrice(), 10);
        });
      }

      /* Listen for variant change events (dispatched by product.js) */
      document.addEventListener('product:variant-change', (e) => {
        /* Only react to events from our own section */
        if (!e.detail || !e.detail.variant || !e.detail.variant.price) return;
        if (this.sectionId && e.detail.sectionId !== this.sectionId) return;
        
        this.unitPrice = e.detail.variant.price;
        this.compareAtPrice = e.detail.variant.compare_at_price || null;
        this.updatePrice();
      });
    }

    updatePrice() {
      if (!this.quantityInput || !this.priceDisplay) return;

      const quantity = parseInt(this.quantityInput.value) || 1;
      const totalPrice = this.unitPrice * quantity;
      const totalCompareAt = this.compareAtPrice != null ? this.compareAtPrice * quantity : 0;
      const hasDiscount = totalCompareAt > totalPrice;

      /* Use the theme's global formatMoney function */
      const format = window.theme?.settings?.money_with_currency_format || "${{amount}}";
      const formatCents = (cents) => typeof formatMoney === 'function'
        ? formatMoney(cents, format)
        : this.fallbackFormatMoney(cents);

      const formattedPrice = formatCents(totalPrice);

      /* Same logic as .td-default-product__price-prices: show strikethrough when compare_at > price */
      if (hasDiscount) {
        const formattedCompareAt = formatCents(totalCompareAt);
        this.priceDisplay.innerHTML = '<s class="th-add-to-cart-price__compare-at">' + formattedCompareAt + '</s> ' + formattedPrice;
      } else {
        this.priceDisplay.textContent = formattedPrice;
      }

      /* Update sticky ATC price if it exists */
      if (this.stickyPriceDisplay) {
        if (hasDiscount) {
          const formattedCompareAt = formatCents(totalCompareAt);
          this.stickyPriceDisplay.innerHTML = '<s class="th-add-to-cart-price__compare-at">' + formattedCompareAt + '</s> ' + formattedPrice;
        } else {
          this.stickyPriceDisplay.textContent = formattedPrice;
        }
      }
    }

    /* Fallback formatter if global formatMoney is not available */
    fallbackFormatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  customElements.define("td-default-product-atc-price", TdDefaultProductAtcPrice);
}
